import React from 'react'
import BookingReportTable from './Components/BookingReportTable'

const BookingReport = () => {
    return (
        <div className="container-fluid admin-module-page py-4">
            <div className="admin-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
                <div>
                    <span className="admin-page-kicker">Hotel Management</span>
                    <h3 className="admin-page-title fw-bold mb-1">Booking Reports</h3>
                    <p className="admin-page-description mb-0">
                        Review booking activity, payment state, and time-based filters.
                    </p>
                </div>
                <span className="admin-chip">
                    <i className="bi bi-bar-chart"></i>
                    Report filters and export
                </span>
            </div>

            <div className="card admin-surface-card mb-4">
                <div className="card-header admin-surface-header">
                    <div className="d-flex flex-column flex-md-row justify-content-between gap-2 align-items-md-center">
                        <div>
                            <h5 className="card-title mb-1">Search Reports Here</h5>
                            <p className="text-muted mb-0 small">
                                Use the filters below to narrow down booking and payment information.
                            </p>
                        </div>
                        <button type="button" className="btn btn-primary btn-sm px-4">
                            Search
                        </button>
                    </div>
                </div>
                <div className="card-body admin-surface-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">From <span className="text-danger">*</span></label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="bi bi-calendar-plus"></i></span>
                                <input type="date" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">To<span className="text-danger"> *</span></label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="bi bi-calendar-minus"></i></span>
                                <input type="date" name="datefilter" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Booking Status</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="bi bi-house"></i></span>
                                <select className="form-select">
                                    <option defaultValue='selected'>Find Booking Status</option>
                                    <option value="1">Pendding</option>
                                    <option value="2">Cancle</option>
                                    <option value="3">Check In</option>
                                    <option value="4">Check Out</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Payment Status</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="bi bi-cash"></i></span>
                                <select className="form-select">
                                    <option defaultValue='selected'>Find Payment Status</option>
                                    <option value="1">Pendding</option>
                                    <option value="2">Cancle</option>
                                    <option value="3">Complete</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card admin-surface-card">
                <div className="card-header admin-surface-header">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <h5 className="card-title mb-0">Report Results</h5>
                        <span className="admin-chip">
                            <i className="bi bi-table"></i>
                            Booking data
                        </span>
                    </div>
                </div>
                <div className="card-body admin-surface-body">
                    <BookingReportTable />
                </div>
            </div>
        </div>
    )
}

export default BookingReport
